import axios from 'axios';
import { LTI_1P3_POST_ASSIGNMENT } from '../../constants/endpoints';

const saveLti1p3Assignment = (spaceId, assignmentData) =>
  axios.post(LTI_1P3_POST_ASSIGNMENT({ spaceId }), assignmentData, {
    withCredentials: true,
  });

export default saveLti1p3Assignment;
